import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {IStore} from '../../../stores/store';
import {debounceTime, finalize, switchMap, tap} from 'rxjs/operators';
import {StoresService} from '../../../stores/services/stores.service';
import {LabelingService} from '../../labeling.service';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';
import {Observable} from "rxjs";

@Component({
    selector: 'app-store-autocomplete',
    templateUrl: './store-autocomplete.component.html',
    styleUrls: ['./store-autocomplete.component.scss'],
    standalone: false
})
export class StoreAutocompleteComponent implements OnInit {

  @Input() formGroup: FormGroup;
  @Input() required = true;
  @Input() limitToAccountIds: number[] = [];
  @Input() id = 'store';

  _selected?: IStore;

  @Input('selected')
  set selected(store: any) {
    this._selected = store;

    this.formGroup.patchValue({
      store: store,
    });
  }

  @Output() storeChanged = new EventEmitter<IStore>();

  filteredStores: IStore[] = [];
  isLoading = false;
  chooseStoreLabel : Observable<string>;
  storeNameRequiredLabel : Observable<string>;

  constructor(
    private fb: FormBuilder,
    private storesService: StoresService,
    public labelingService: LabelingService,
  ) {
    this.chooseStoreLabel = this.labelingService.getStoreSentenceLabel(marker('Choose Store'), marker('Choose'));
    this.storeNameRequiredLabel = this.labelingService.getStoreSentenceLabel(marker('Store name is required'), marker('name is required'));
  }

  ngOnInit() {
    const validators = this.required ? [Validators.required] : [];
    this.formGroup.addControl('store', this.fb.control(this._selected ? this._selected : '', validators));

    this.formGroup
      .get('store')
      .valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.isLoading = true),
        switchMap(value => this.storesService.filterStoresByNameNumberOrNickname(value)
          .pipe(
            finalize(() => this.isLoading = false),
          ),
        ),
      )
      .subscribe(response => {
        if (this.formGroup.get('store').value === '') {
          this.onStoreSelectedInternal(undefined);
        }
        if (this.limitToAccountIds.length === 0) {
          this.filteredStores = response.list;
        } else {
          this.filteredStores = response.list.filter(store => this.limitToAccountIds.includes(store.accountId));
        }
      });
  }

  displayStoreName(store?: IStore) {
    if (store) {
      return store.storeName;
    }
  }

  onStoreSelectedInternal(store: IStore) {
      this._selected = store;
      this.storeChanged.emit(store);
  }
}
